import React from "react";
import DetailsStyle from "styles/application/DetailsStyle";

// Init styled components
const AD = DetailsStyle();

const DetailsPanel = ({
	header,
	dataCount,
	description,
	countStyle = null,
	showHeader = true,
	testIdPrefix = null,
}) => {
	const headerTestId = testIdPrefix ? `${testIdPrefix}-header` : undefined;
	const countTestId = testIdPrefix ? `${testIdPrefix}-count` : undefined;
	const descriptionTestId = testIdPrefix ? `${testIdPrefix}-description` : undefined;

	return (
		<AD.ParentContainer>
			{showHeader && (
				<AD.HeaderText data-testid={headerTestId}>
					{dataCount === null ? (
						<>{header}</>
					) : (
						<>
							{header}{" "}
							<span data-testid={countTestId} style={countStyle ? countStyle : null}>({dataCount})</span>
						</>
					)}
				</AD.HeaderText>
			)}
			<AD.InfoText data-testid={descriptionTestId}>{description}</AD.InfoText>
		</AD.ParentContainer>
	);
};

export default DetailsPanel;
